<template>
  <section id="booking" class="services">
    <div class="container price-card">
      <div class="row fade-in">
        <div class="col-12">
          <h1 class="text-center">Termin buchen</h1>
        </div>
      </div>

      <div class="row fade-in">
        <div class="col-12 text-center">
          <p class="booking-text">
            Buchen Sie bequem Ihren Termin online
            Wählen Sie Ihren Service und sichern Sie sich Ihren persönlichen Wunschtermin.
          </p>
          <a href="https://salonkee.de/salon/haarlem-friseure"
             class="btn btn-primary mt-4"
             target="_blank"
             rel="noopener">
            Jetzt Termin buchen
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Booking"
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/imports';

h1 {
  text-transform: uppercase;
  letter-spacing: 4px;
}

.booking-text {
  max-width: 700px;
  margin: 0 auto;
  font-size: 18px;
  line-height: 1.6;
}

.btn {
  &:hover {
    color: white;
  }
}
</style>